import State from './State';
import order from '../order/initialState';
import estimations from '../estimations/initialState';
import user from '../user/initialState';
import products from '../products/initialState';
import admin from '../admin/initialState';

const initialState: State = {
    application: {
        prevLocation: '',
        location: '',
        extraFeatures: [],
        loader: false
    },
    notifications: [],
    products,
    order,
    estimations,
    user,
    admin,
    userOrders: [],
    userEstimations: [],
    estimationDetails: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/application/core/initialState.ts